export function SoftCheckSVG() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='75'
			zoomAndPan='magnify'
			viewBox='0 0 56.25 56.249997'
			height='75'
			preserveAspectRatio='xMidYMid meet'
			version='1.0'
		>
			<defs>
				<clipPath id='131eba5375'>
					<path
						d='M 1.296875 1.296875 L 54 1.296875 L 54 54 L 1.296875 54 Z M 1.296875 1.296875 '
						clipRule='nonzero'
					/>
				</clipPath>
			</defs>
			<g clipPath='url(#131eba5375)'>
				<path
					fill='#a6a6a6'
					d='M 52.972656 48.792969 L 41.984375 38.410156 C 45.117188 34.496094 47.003906 29.546875 47.003906 24.152344 C 47.011719 11.550781 36.753906 1.296875 24.152344 1.296875 C 11.550781 1.296875 1.296875 11.550781 1.296875 24.152344 C 1.296875 36.753906 11.550781 47.011719 24.152344 47.011719 C 29.546875 47.011719 34.503906 45.121094 38.410156 41.988281 L 48.792969 52.972656 C 48.832031 53.011719 48.875 53.058594 48.910156 53.089844 C 50.09375 54.214844 51.964844 54.160156 53.089844 52.972656 C 54.214844 51.785156 54.160156 49.914062 52.972656 48.792969 Z M 5.515625 24.152344 C 5.515625 13.875 13.875 5.519531 24.148438 5.519531 C 34.417969 5.519531 42.78125 13.882812 42.78125 24.152344 C 42.78125 34.425781 34.417969 42.785156 24.148438 42.785156 C 13.875 42.785156 5.515625 34.425781 5.515625 24.152344 Z M 5.515625 24.152344 '
					fillOpacity='1'
					fillRule='nonzero'
				/>
			</g>
			<path
				fill='#a6a6a6'
				d='M 26.949219 10.832031 C 25.738281 8.625 22.5625 8.625 21.351562 10.832031 L 11.710938 28.355469 C 10.542969 30.480469 12.082031 33.089844 14.511719 33.089844 L 33.800781 33.089844 C 36.230469 33.089844 37.769531 30.480469 36.601562 28.355469 Z M 22.414062 15.953125 C 22.414062 14.996094 23.191406 14.21875 24.148438 14.21875 C 25.105469 14.21875 25.878906 14.996094 25.878906 15.953125 L 25.878906 22.152344 C 25.878906 23.113281 25.105469 23.886719 24.148438 23.886719 C 23.191406 23.886719 22.414062 23.113281 22.414062 22.152344 Z M 24.152344 29.539062 C 23.0625 29.539062 22.183594 28.65625 22.183594 27.570312 C 22.183594 26.484375 23.066406 25.597656 24.152344 25.597656 C 25.242188 25.597656 26.125 26.480469 26.125 27.570312 C 26.125 28.660156 25.242188 29.539062 24.152344 29.539062 Z M 24.152344 29.539062 '
				fillOpacity='1'
				fillRule='nonzero'
			/>
		</svg>
	);
}
